import { render, staticRenderFns } from "./PropertyProductManagement.vue?vue&type=template&id=2b7c85e0&scoped=true&"
import script from "./PropertyProductManagement.vue?vue&type=script&lang=js&"
export * from "./PropertyProductManagement.vue?vue&type=script&lang=js&"
import style0 from "./PropertyProductManagement.vue?vue&type=style&index=0&id=2b7c85e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7c85e0",
  null
  
)

export default component.exports